import { Flex } from 'theme-ui';

import { Option } from './Option';
import { themed } from './Options.theme';

export const Options = themed(({ theme, options, handle, image }) => {
  return (
    <Flex data-comp={Options.displayName} sx={theme.options}>
      {options &&
        Object.keys(options)?.map((optionName, index) => {
          // Each option group. e.g Sizes, Colors..
          const option = options[optionName];
          if (option?.length < 2 || option?.[0] === 'Default Title')
            return null;

          return (
            <Option
              key={optionName}
              optionName={optionName}
              index={index}
              options={options}
              handle={handle}
              image={image}
            />
          );
        })}
    </Flex>
  );
});

Options.displayName = 'Options';
